/// <amd-module name="Feed/Legacy/Protocols/Components/PackageDevelopment" />
import * as React from "react";

import * as Utils_String from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";

import { CiConstants } from "Feed/Common/Constants/Constants";
import { MinimalPackageVersion, Package, UpstreamSource } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";
import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { PackageUpstreamSource } from "Feed/Legacy/Components/PackageUpstreamSource";
import { CustomerIntelligenceHelper } from "Feed/Legacy/Helpers/CustomerIntelligenceHelper";
import { isSafeProtocol } from "Feed/Legacy/Helpers/UrlHelper";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";

export interface IPackageDevelopmentProps {
    pageContext: IVssPageContext;
    /**
     * Project attributes specified by each protocol
     */
    projectAttributes: IProjectAttribute[];
    /**
     * Selected package
     */
    packageSummary: Package;
    /**
     * Selected package version
     */
    packageVersion: MinimalPackageVersion;
    /**
     * List of all upstream sources. Only pass it if feed is not project scoped
     */
    upstreamSources?: UpstreamSource[];
}

export interface IProjectAttribute {
    iconClass: string;
    url?: string;
    onClickCiFeature?: string;
    text: string;
}

export class PackageDevelopment extends React.PureComponent<IPackageDevelopmentProps> {
    public render(): JSX.Element {
        if (!this.showDevelopment()) {
            return null;
        }

        const showProject = this.props.projectAttributes && this.props.projectAttributes.length > 0;
        const showSource = this.props.upstreamSources;
        return (
            <div>
                {(showProject || showSource) && (
                    <PackageAttribute
                        title={PackageResources.PackageAttributeTitle_Development}
                        className="package-development"
                    >
                        {showSource && (
                            <div>
                                <div className="package-group-header" role="heading" aria-level={3}>
                                    {PackageResources.PackageSource}
                                </div>
                                <div className="package-attribute-item">
                                    <span className="bowtie-icon bowtie-packages package-attribute-item-icon" />
                                    <PackageUpstreamSource
                                        pageContext={this.props.pageContext}
                                        packageSummary={this.props.packageSummary}
                                        packageVersion={this.props.packageVersion}
                                        upstreamSources={this.props.upstreamSources}
                                    />
                                </div>
                            </div>
                        )}
                        {showProject && (
                            <div>
                                <div className="package-group-spacer" />
                                <div className="package-group-header" role="heading" aria-level={3}>
                                    {PackageResources.PackageDevelopment_ProjectTitle}
                                </div>
                                {this.props.projectAttributes.map(
                                    (projectAttribute: IProjectAttribute, index: number) => {
                                        return (
                                            <div className="package-attribute-item" key={index}>
                                                <span
                                                    className={
                                                        "package-attribute-item-icon " + projectAttribute.iconClass
                                                    }
                                                />
                                                {isSafeProtocol(projectAttribute.url || "") ? (
                                                    <ExternalLink
                                                        pageContext={this.props.pageContext}
                                                        href={projectAttribute.url}
                                                        ciContext={CiConstants.PackageDevelopment}
                                                        onClick={() =>
                                                            CustomerIntelligenceHelper.publishEvent(
                                                                this.props.pageContext,
                                                                projectAttribute.onClickCiFeature
                                                            )
                                                        }
                                                        linkAriaLabel={Utils_String.format(
                                                            "{0}: {1}",
                                                            projectAttribute.text,
                                                            projectAttribute.url
                                                        )}
                                                    >
                                                        {projectAttribute.text}
                                                        <span className="bowtie-icon bowtie-navigate-external" />
                                                    </ExternalLink>
                                                ) : (
                                                    <div className="project-attibute-text">{projectAttribute.text}</div>
                                                )}
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        )}
                    </PackageAttribute>
                )}
            </div>
        );
    }

    private showDevelopment(): boolean {
        return (
            this.props.upstreamSources != null ||
            (this.props.projectAttributes && this.props.projectAttributes.length > 0)
        );
    }
}
